import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
// icons, ui and images
import { Badge, CircularProgress, ListItemText, Menu, MenuItem } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ratnaImage from '../../../images/discovery/ratna.svg';
import chromeIcon from '../../../images/icons/chrome.svg';
import { fetchNotifications, setAutomatedPaymentsState, toggleShowNotificationTooltip } from '../../../redux/notifications/notificationActions';
// utils
import { setOnboaringStatus, setOnboaringStep } from '../../../redux/onboarding/onboardingActions';
import { fetchMultiBrandAccounts, showBuyRatnaModal } from '../../../redux/user/userActions';
import { updateSeenStatus } from '../../../services/notifications.service';
import { setStorage } from '../../../utils/auth-utils';
import { getUserAvatar } from '../../../utils/avatar-utils';
import { onboardingData } from '../../../utils/data/onboardingData';
import { debounce, handleLogout } from '../../../utils/global';
import OutofRatnaModal from '../../Dashboard/discovery/components/OutofRatnaModal';
import DemographicsDrawer from '../../Dashboard/discovery/DemographicsDrawer';
// components
import AvatarComponent from '../AvatarComponent/AvatarComponent';
import NotificationsComponent from '../NotificationComponent/NotificationsComponent';
import PopoverComponent from '../OnboardingComponents/PopoverComponent';
// styles
import './_headerComponent.scss';
import AutomatedPaymentsModal from '@/components/Dashboard/Lists/components/Payments/AutomatedPayments/AutomatedPaymentsModal';
import LitePlanModal from '@/components/Dashboard/settings/modals/LitePlanModal';
import EditOutlineIcon from '@/components/Icons/icons/EditOutlineIcon';
import LogoutIcon from '@/components/Icons/icons/LogoutIcon';
import { automatedPaymentsDefaultState } from '@/redux/notifications/notificationReducer';
import { setShortcutModalOpenStatus, setShortcutsDisableStatus } from '@/redux/shortcuts/shortcutsActions';
import { SHORTCUT_MODAL_OPEN_PAGE } from '@/redux/shortcuts/shortcutsTypes';
import { AUTOMATED_PAYMENTS_MODAL_STATUS } from '@/utils/constants/automations';
import { inboxShortcuts, profileShortcuts, relationshipShortcuts } from '@/utils/data/shortcuts';
import { Mixpanel } from '@/utils/mixpanel';
import { REMOVE_DATA_FROM_MULTIBRAND_TOKENS_DATA } from '@/utils/multibrand-utils';
import { sleep } from '@/utils/ts/functions';
import { ONBOARDING_VIDEO_URL } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/onboarding';
import BellNotification from '../../../components/Icons/icons/BellNotification';
import Book from '../../../components/Icons/icons/Book';
import Bulb from '../../../components/Icons/icons/Bulb';
import Electricity from '../../../components/Icons/icons/Electricity';
import SettingsOutline from '../../../components/Icons/icons/SettingsOutline';
import useQueryParam from '../../../hooks/useQueryParam';
import { updateChangelogLastViewedVersion } from '../../../services/changelog.service';
import { signOut } from '../../../services/list.service';
import { isJsrStorageKey, SWITCH_ID_KEY } from '../../../utils/constants';
import { getCommandKey } from '../../../utils/global';
import { checkOnboardingStep } from '../../../utils/survey-utils';
import OverduePaymentHeader from '../../Dashboard/Subscription/components/OverduePaymentHeader';
import NotesOutline from '../../Icons/icons/NotesOutline';
import SearchIcon from '../../Icons/icons/SearchIcon';
import TrialBanner from '../Banner/TrialBanner';
import ChangeLogDrawer from '../ChangeLog/ChangeLogDrawer';
import CustomShortcutTooltip from '../CustomTooltip/CustomShortcutTooltip';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import InputComponent from '../InputComponent/InputComponent';
import WarningModal from '../ModalComponent/WarningModal';
import SafeIframe from '../SafeIframe/SafeIframe';
import ShortString from '../ShortString/ShortString';
import ChangelogDropdownOption from './ChangelogDropdownOption';
import AddAccountModal from './MultiBrandLogin/AddAccountModal/AddAccountModal';
import ChooseAccountModal from './MultiBrandLogin/ChooseAccountModal/ChooseAccountModal';
import SwitchContainer from './MultiBrandLogin/SwitchContainer';
import ShortcutsModal from './ShortcutsModal/ShortcutsModal';
import SwitchButton from './SwitchButton';


// import CSDowntimeBanner from '../../Dashboard/home/components/CSDowntimeBanner';
// import Chip from '../Chip/Chip';

export default function HeaderComponent({
  title,
  showSearchBar = true,
  handleSearch,
  isArchived,
  handleClearSearch,
  changeTab,
  dropDownOptions,
  dropDownComponent,
  dropDownWidth,
  dropDownWrapper = (props) => props.children,
  noOptionsComponent,
  searchPlaceholder = 'Search by name, username, or email',
  style = {},
  rightSection,
  isLoading,
  showBook = true,
  showBulb = true,
  wideSearchInput = false,
  className = '',
  wrapperClassName = '',
  middleSlot,
  fullWidth = false,
  disableShortcutsOnFocus = true,
  dropDownMaxHeight = '246px',
}) {
  const [queryString, setQueryString] = useState('');
  const queryParam = useQueryParam();
  const [showProfileDropdown, setShowProfileDropdown] = useState(null);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(null);
  const [showHelpDropdown, setShowHelpDropdown] = useState(null);
  const [showChangelogDropdown, setShowChangelogDropdown] = useState(null);

  const [isChangeLogViewed, setIsChangeLogViewed] = useState({
    flag: true,
    count: 0,
  });

  const [selectedInfluencer, setSelectedInfluencer] = useState({});
  const [showDemographics, setShowDemographics] = useState(false);
  const [demographicsId, setDemographicsId] = useState(false);
  const [changeLogOpen, setChangeLogOpen] = useState(() => queryParam.get('changelog') === 'true' || false);

  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [ratnaAnchorEl, setRatnaAnchorEl] = useState(null);
  const [showOutofRatnaModal, setShowOutofRatnaModal] = useState(false);
  const [showNotificationTooltip, setShowNotificationTooltip] = useState(false);
  const [notificationTooltipMessage, setNotificationTooltipMessage] = useState('');
  const [notificationIds, setNotificationIds] = useState([]);

  const [searchQuery, setSearchQuery] = useState(null);

  const { onboardingStep } = useSelector((state) => state.onboarding);
  const { userDetails, userProfile, teamMembers, multiBrands } = useSelector((state) => state.user);
  const { notifications, isTooltipShown, unseenCount, disablePolling } = useSelector((state) => state.notifications);
  const { list } = useSelector((state) => state.changelog);

  const [switchUserModal, setSwitchUserModal] = useState(false);

  const [showChooseAccountModal, setShowChooseAccountModal] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showDeleteWarningModal, setShowDeleteWarningModal] = useState(false);
  const [accountToRemove, setAccountToRemove] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);

  const [isSearchBarActive, setIsSearchBarActive] = useState(false);

  const { isShortcutsDisabled, shortcutModalStatus } = useSelector((state) => state.shortcuts);

  const handleRemoveAccount = async () => {
    setLoading(true);

    const updatedData = REMOVE_DATA_FROM_MULTIBRAND_TOKENS_DATA(accountToRemove);

    dispatch(fetchMultiBrandAccounts(updatedData.map((data) => data.token)));
    NotificationManager.success('Account Removed Successfully');
    setShowDeleteWarningModal(false);
    setAccountToRemove(null);
    setSelectedBrand(null);
    setLoading(false);
  };

  const brandToRemove = multiBrands?.find((brand) => brand.connectedBrandTeamMemberId === accountToRemove);

  const inputRef = useRef();

  const searchRef = useRef();
  const notificationRef = useRef();
  const profileRef = useRef();
  const ratnaRef = useRef();
  const { pathname } = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { automatedPaymentsState } = useSelector((state) => state.notifications);

  const handleChange = debounce((e) => {
    const { value } = e.target;
    setQueryString(value);
    if (value.length >= 3) {
      handleSearch(value);
    }
    if (value.length === 0) {
      handleClearSearch();
    }
  }, 500);

  const handleSwitchUser = () => {
    setSwitchUserModal(true);
  };

  const clearSearch = () => {
    searchRef.current.value = '';
    setQueryString('');
    setSearchQuery(null);
    handleClearSearch();
  };

  const startTour = () => {
    dispatch(setOnboaringStatus(false));
    dispatch(setOnboaringStep(0));
    setShowHelpDropdown(null);
    document.querySelector('.root-overlay-container').style.display = 'block';
  };

  const handleUpdateSeenStatus = async () => {
    const response = await updateSeenStatus({ notificationIds });
    if (response?.status) {
      setNotificationIds([]);
      dispatch(fetchNotifications());
    }
  };
  const handleClickShowChangelog = async () => {
    if (!list || list?.length === 0) return;
    const response = await updateChangelogLastViewedVersion({ version: list?.[0]?.version });
    if (response?.status) {
      setIsChangeLogViewed({ flag: true, count: 0 });
    }
  };

  const openChangeLog = () => {
    handleClickShowChangelog();
    setIsChangeLogViewed({ flag: true, count: 0 });
    setShowChangelogDropdown(null);
    navigate(`${pathname}?changelog=true`);
    setShowHelpDropdown(false);
    setChangeLogOpen(true);
    Mixpanel.identify(userDetails?._id);
  };

  useEffect(() => {
    if (checkOnboardingStep('ratnaCount', onboardingStep)) {
      setRatnaAnchorEl(ratnaRef.current);
    } else if (checkOnboardingStep('profile', onboardingStep)) {
      setProfileAnchorEl(profileRef.current);
    } else if (checkOnboardingStep('notifications', onboardingStep)) {
      setNotificationAnchorEl(notificationRef.current);
    }
  }, [onboardingStep]);

  useEffect(() => {
    if (disablePolling) return;
    const intervalId = setInterval(() => {
      dispatch(fetchNotifications(null, 'polling'));
    }, 20_000);

    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch, disablePolling]);

  useEffect(() => {
    const unseenNotificationDemographics =
      notifications.filter((notification) => !notification?.seen && notification.type === 'demographics').length > 0
        ? true
        : false;
    const unseenEmailDisconnect =
      notifications.filter((notification) => !notification?.seen && notification.type === 'emailDisconnect').length > 0
        ? true
        : false;
    if (unseenNotificationDemographics) {
      setNotificationTooltipMessage('🌎 Demographics are Ready!');
    }
    if (unseenEmailDisconnect) {
      setNotificationTooltipMessage('✉️ Campaigns are paused!');
    }
    if (!isTooltipShown && (unseenNotificationDemographics || unseenEmailDisconnect)) {
      setTimeout(() => {
        setShowNotificationTooltip(unseenNotificationDemographics || unseenEmailDisconnect);
        setTimeout(() => {
          setShowNotificationTooltip(false);
        }, 5000);
      }, [500]);
      dispatch(toggleShowNotificationTooltip(true));
    }
  }, [notifications]);

  const currentShortcutKey = useMemo(() => {
    if (pathname.includes('inbox')) {
      return SHORTCUT_MODAL_OPEN_PAGE.INBOX;
    } else if (pathname.includes('profile')) {
      return SHORTCUT_MODAL_OPEN_PAGE.PROFILE;
    } else if (pathname.includes('relationship')) {
      return SHORTCUT_MODAL_OPEN_PAGE.RELATIONSHIP_BOARD;
    }
    return null;
  }, [pathname]);

  useEffect(() => {
    const downHandler = (e) => {
      e.stopPropagation();

      if (isShortcutsDisabled) return;

      const key = e.key;
      const isCmdPressed = e.metaKey;
      const isCtrlPressed = e.ctrlKey;

      if ((key === 'k' || key === 'K') && (isCmdPressed || isCtrlPressed)) {
        e.preventDefault();
        dispatch(setShortcutModalOpenStatus(!shortcutModalStatus ? currentShortcutKey : null));
      }
      if (key === 'Escape') {
        dispatch(setShortcutModalOpenStatus(null));
      }
    };

    window.addEventListener('keydown', downHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, [dispatch, isShortcutsDisabled, shortcutModalStatus]);

  useEffect(() => {
    setIsChangeLogViewed({
      flag: userDetails?.hasViewedLatestChangeLog,
      count: userDetails?.unseenChangeLogCount || 0,
    });
  }, [userDetails?.hasViewedLatestChangeLog, userDetails?.unseenChangeLogCount]);

  const [showLitePlanModal, setShowLitePlanModal] = useState(false);

  const handleFocus = async () => {
    await sleep(300);
    setIsSearchBarActive(true);
  };

  const handleBlur = async () => {
    await sleep(300);
    setIsSearchBarActive(false);
  };

  const getShortcutButton = () => {
    const key = currentShortcutKey;

    if (key) {
      return (
        <CustomShortcutTooltip title="Shortcuts" keys={[getCommandKey(), 'K']}>
          <div
            className="rounded-icons"
            onClick={() => {
              dispatch(setShortcutModalOpenStatus(currentShortcutKey));
            }}>
            <Electricity color="#CA8A04" />
          </div>
        </CustomShortcutTooltip>
      );
    }

    return showBook ? (
      <div className="rounded-icons" onClick={(e) => setShowHelpDropdown(e.currentTarget)}>
        <Book />
      </div>
    ) : null;
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('focus', handleFocus);
      inputRef.current.addEventListener('blur', handleBlur);
    }

    // Cleanup event listeners on component unmount
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('focus', handleFocus);
        inputRef.current.removeEventListener('blur', handleBlur);
      }
    };
  }, []);

  const currentUser = useMemo(() => {
    return teamMembers.find((member) => userDetails?.teamMemberId === member?._id);
  }, [teamMembers, userDetails]);

  const handleClickRemoveConnectedAccount = (_id) => {
    setAccountToRemove(_id);
    setShowDeleteWarningModal(true);
  };

  return (
    <>
      <div className={`w-full bg-white relative ${wrapperClassName}`}>
        <div className={`header-row ${fullWidth ? '' : 'max-screen-size'} ${className}`} style={{ ...style }}>
          <div className="flex justify-center items-center gap-2">
            {typeof title === 'string' ? <h3 className="header-text">{title}</h3> : title}
            {isArchived && (
              <CustomTooltip title="Unarchive from bottom left" arrow>
                <p
                  style={{
                    color: 'var(--text-yellow)',
                    border: '1px solid var(--text-yellow)',
                    width: 'fit-content',
                    padding: '5px 12px 5px 12px',
                    fontSize: '12px',
                    fontWeight: '500',
                    borderRadius: '20px',
                    cursor: 'default',
                  }}>
                  Archive
                </p>
              </CustomTooltip>
            )}
          </div>

          {middleSlot && <div className="header-middle-slot">{middleSlot}</div>}

          <div className="header-right-div header-actions-container">
            {showSearchBar && (
              <div className="header-searchbar">
                <InputComponent
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    handleChange(e);
                  }}
                  placeholder={searchPlaceholder}
                  ref={(r) => {
                    inputRef.current = r;
                    searchRef.current = r;
                  }}
                  inputWrapperClass={
                    wideSearchInput ? 'header-search-input-wrapper-wide' : 'header-search-input-wrapper'
                  }
                  value={searchQuery}
                  left={<SearchIcon />}
                  right={
                    isLoading ? (
                      <CircularProgress size={20} sx={{ color: 'var(--purple-p-400)' }} />
                    ) : searchQuery?.length > 0 ? (
                      <CloseIcon fontSize="small" className="cursor-pointer" onClick={clearSearch} />
                    ) : (
                      <></>
                    )
                  }
                  onFocus={() => {
                    if (disableShortcutsOnFocus) {
                      dispatch(setShortcutsDisableStatus(true));
                    }
                  }}
                  onBlur={() => {
                    dispatch(setShortcutsDisableStatus(false));
                  }}
                />
                {isSearchBarActive && queryString.length >= 3 && dropDownOptions && (
                  <div
                    className="search-dropdown-component"
                    style={{
                      width: dropDownWidth || inputRef.current?.clientWidth,
                      zIndex: 1000,
                      maxHeight: dropDownMaxHeight || '246px',
                    }}
                    onClick={() => {
                      setQueryString('');
                      if (searchRef.current) {
                        searchRef.current.value = '';
                      }
                    }}>
                    {dropDownOptions.length > 0 ? (
                      dropDownOptions.map((option, index) => dropDownComponent(option, index))
                    ) : (
                      <>{noOptionsComponent}</>
                    )}
                  </div>
                )}
              </div>
            )}
            {rightSection}

            <div className="ratna-container" onClick={() => dispatch(showBuyRatnaModal('light'))} ref={ratnaRef}>
              <img src={ratnaImage} alt="" />
              <p>{userDetails?.balance}</p>
            </div>

            {getShortcutButton(pathname)}

            {/* {showBulb && (
              <div
                className="rounded-icons"
                onClick={(e) => {
                  if (!isChangeLogViewed.flag && isChangeLogViewed.count > 0) {
                    openChangeLog();
                  } else {
                    setShowChangelogDropdown(e.currentTarget);
                  }
                }}>
                <Badge
                  showZero={!isChangeLogViewed.flag}
                  color="error"
                  badgeContent={isChangeLogViewed?.count}
                  sx={{
                    color: '#fff',
                    '& .MuiBadge-badge': {
                      right: 3,
                      top: 5,
                      width: '15px !important',
                      height: '15px !important',
                      minWidth: '15px !important',
                      minHeight: '15px !important',
                      fontSize: '10px',
                    },
                  }}>
                  <Bulb />
                </Badge>
              </div>
            )} */}

            <CustomTooltip
              className="demographicsNotification"
              title={showNotificationTooltip ? notificationTooltipMessage : ''}
              light={true}
              opened={showNotificationTooltip}>
              <div
                className="rounded-icons last"
                onClick={(e) => {
                  setShowNotificationDropdown(e.currentTarget);
                }}
                ref={notificationRef}>
                <Badge
                  showZero={unseenCount > 0}
                  color="error"
                  badgeContent={unseenCount}
                  sx={{
                    color: '#fff',
                    '& .MuiBadge-badge': {
                      right: 3,
                      top: 5,
                      width: unseenCount > 99 ? '20px !important' : '15px !important',
                      height: unseenCount > 99 ? '20px !important' : '15px !important',
                      minWidth: '15px !important',
                      minHeight: '15px !important',
                      fontSize: '10px',
                    },
                  }}>
                  <BellNotification />
                </Badge>
              </div>
            </CustomTooltip>

            {/* eslint-disable-next-line no-prototype-builtins  */}
            {userProfile.hasOwnProperty('profile_link') && (
              <div
                className="user-profile-div"
                ref={profileRef}
                onClick={(e) => setShowProfileDropdown(e.currentTarget)}>
                {userProfile?.profile_link ? (
                  <AvatarComponent
                    src={userProfile?.profile_link}
                    alt={userProfile?.first_name || userProfile?.email}
                    size={36}
                  />
                ) : (
                  <div style={{ width: '32px' }} className="center">
                    <SafeIframe>{getUserAvatar(`${userProfile?.first_name}${userProfile?.last_name}`)}</SafeIframe>
                  </div>
                )}
                <h3>
                  {userDetails?.first_name} <ArrowDownIcon />
                </h3>
              </div>
            )}

            <MenuWrapper
              anchorEl={showHelpDropdown}
              open={Boolean(showHelpDropdown)}
              onClose={() => setShowHelpDropdown(null)}
              width={300}>
              <div className="help-dropdown">
                <h2>Getting Started with SARAL 🎉</h2>
                <div className="help-buttons-container">
                  <button>
                    <a
                      href={ONBOARDING_VIDEO_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#7357e9' }}
                      onClick={() => {
                        Mixpanel.identify(userDetails?._id);
                        Mixpanel.track('watch_tutorial', {
                          userId: userDetails?._id,
                        });
                      }}>
                      <PlayCircleOutlineIcon />
                      Watch Tutorial
                    </a>
                  </button>
                  <button onClick={startTour}>
                    <ArticleOutlinedIcon />
                    Start Tour
                  </button>
                </div>
              </div>
              <div className="help-dropdown" style={{ borderTop: '1px solid var(--light-grey' }}>
                <h2>The SARAL Chrome Companion</h2>
                <div className="help-buttons-container">
                  <button>
                    <a
                      href="https://chrome.google.com/webstore/detail/saral/fiienncdapmaacfjbfaomcfogknalfep?hl=en-US"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#7357e9' }}>
                      <img src={chromeIcon} alt="chrome icon" />
                      Add to Chrome
                    </a>
                  </button>
                </div>
              </div>
            </MenuWrapper>

            <MenuWrapper
              anchorEl={showChangelogDropdown}
              open={Boolean(showChangelogDropdown)}
              onClose={() => setShowChangelogDropdown(null)}
              width={300}>
              <div className="changelog-dropdown">
                <p className="changelog-dropdown-heading">What&apos;s new?</p>
                <div className="changelog-list">
                  {list
                    .filter((item) => item.isActive)
                    .map((listItem, idx) => {
                      return <ChangelogDropdownOption key={idx} changeLog={listItem} />;
                    })}
                </div>
                <div className="changelog-view-button" onClick={openChangeLog}>
                  <NotesOutline />
                  View Changelog
                </div>
              </div>
            </MenuWrapper>

            {automatedPaymentsState.showAutomatedPaymentModal && (
              <AutomatedPaymentsModal
                mode={AUTOMATED_PAYMENTS_MODAL_STATUS.EDIT}
                show={automatedPaymentsState.showAutomatedPaymentModal}
                onClose={() => {
                  dispatch(setAutomatedPaymentsState(automatedPaymentsDefaultState));
                }}
                automatedPayment={automatedPaymentsState.automatedPayment}
                influencerName={automatedPaymentsState.influencerName}
                profile_pic={automatedPaymentsState.influencerProfileImg}
                profileId={automatedPaymentsState.influencerData._id.toString()}
                isRetry
              />
            )}

            <MenuWrapper
              anchorEl={showNotificationDropdown}
              open={Boolean(showNotificationDropdown)}
              onClose={() => {
                setShowNotificationDropdown(null);
                if (notificationIds.length > 0) {
                  handleUpdateSeenStatus();
                }
              }}
              width={400}
              maxHeight={465}>
              <NotificationsComponent
                setSelectedInfluencer={setSelectedInfluencer}
                setShowDemographics={setShowDemographics}
                setShowNotificationDropdown={setShowNotificationDropdown}
                setShowLitePlanModal={setShowLitePlanModal}
                setDemographicsId={setDemographicsId}
                notificationIds={notificationIds}
                setNotificationIds={setNotificationIds}
              />
            </MenuWrapper>

            <MenuWrapper
              anchorEl={showProfileDropdown}
              open={Boolean(showProfileDropdown)}
              onClose={() => setShowProfileDropdown(null)}
              sx={{ borderRadius: '8px', overflow: 'hidden' }}
              width={290}>
              <MenuItem onClick={handleSwitchUser} className="menu-item w-full" disableRipple={true}>
                <SwitchContainer
                  setShowChooseAccountModal={setShowChooseAccountModal}
                  setShowProfileDropdown={setShowProfileDropdown}
                  selectedBrand={selectedBrand}
                  setSelectedBrand={setSelectedBrand}
                />
              </MenuItem>
              <MenuItem className="header-component__divide-up" sx={{ padding: 0, width: '100%' }} disableRipple={true}>
                <div className="header-component__user-list">
                  <AvatarComponent
                    src={currentUser?.imageUrl}
                    alt={`${currentUser?.first_name.toUpperCase()} ${currentUser?.last_name.toUpperCase()}`}
                    size={36}
                  />
                  <div>
                    <ShortString
                      name={`${currentUser?.first_name} ${currentUser?.last_name}`}
                      stringLength={18}
                      placement="bottom"
                      className="text-default"
                    />
                    <ShortString
                      name={currentUser?.email}
                      stringLength={18}
                      placement="bottom"
                      className="text-subdued"
                    />
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                onClick={() => navigate('/dashboard/settings')}
                className="header-componnent__popover_action_item header-component__divide-up first"
                disableRipple={true}>
                <ListItemIcon>
                  <SettingsOutline />
                </ListItemIcon>
                <ListItemText>Settings</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={handleLogout}
                className="header-componnent__popover_action_item last"
                disableRipple={true}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </MenuWrapper>
          </div>
          {showDeleteWarningModal ? (
            <WarningModal
              show={showDeleteWarningModal}
              onClose={() => {
                setShowDeleteWarningModal(false);
              }}
              icon="⚠️"
              iconBgColor="var(--yellow-y-50)"
              title="Remove Account?"
              description={
                <p className="mt-2">
                  Are you sure you want to remove <br />
                  <span className="font-medium text-default">{brandToRemove?.brandName}</span> from your linked
                  accounts?
                </p>
              }
              actionButtonText="Yes, remove!"
              actionButtonType="danger"
              actionFunction={handleRemoveAccount}
              cancelButtonText="Cancel"
              width={420}
              showLoading={loading}
            />
          ) : showChooseAccountModal ? (
            <ChooseAccountModal
              show={showChooseAccountModal}
              onClose={() => {
                setShowChooseAccountModal(false);
              }}
              handleShowAddNewAccount={() => {
                setShowAddAccountModal(true);
                setShowChooseAccountModal(false);
              }}
              handleClickRemoveConnectedAccount={handleClickRemoveConnectedAccount}
              selectedBrand={selectedBrand}
              setSelectedBrand={setSelectedBrand}
            />
          ) : showAddAccountModal ? (
            <AddAccountModal
              show={showAddAccountModal}
              onClose={() => {
                setShowAddAccountModal(false);
                setShowChooseAccountModal(true);
              }}
              setSelectedBrand={setSelectedBrand}
            />
          ) : (
            ''
          )}

          <PopoverComponent
            anchorEl={profileAnchorEl}
            setAnchorEl={setProfileAnchorEl}
            onboardingData={onboardingData[12]}
          />
          <PopoverComponent
            anchorEl={notificationAnchorEl}
            setAnchorEl={setNotificationAnchorEl}
            onboardingData={onboardingData[10]}
          />
          <PopoverComponent
            anchorEl={ratnaAnchorEl}
            setAnchorEl={setRatnaAnchorEl}
            onboardingData={onboardingData[11]}
          />

          <DemographicsDrawer
            open={showDemographics}
            onClose={() => setShowDemographics(false)}
            selectedInfluencer={selectedInfluencer}
            demographics_id={demographicsId}
            revealDemographics={false}
            setShowOutofRatnaModal={setShowOutofRatnaModal}
            callFromNotification
          />

          {changeLogOpen && (
            <ChangeLogDrawer
              show={changeLogOpen}
              onClose={() => {
                navigate(pathname);
                setChangeLogOpen(false);
              }}
            />
          )}

          {shortcutModalStatus && shortcutModalStatus === SHORTCUT_MODAL_OPEN_PAGE.INBOX && (
            <ShortcutsModal
              show
              onClose={() => {
                dispatch(setShortcutModalOpenStatus(null));
              }}
              keysData={inboxShortcuts}
              title="Inbox Keyboard Shortcuts"
              isNewShortcut
              width={690}
              topCross
            />
          )}

          {shortcutModalStatus && shortcutModalStatus === SHORTCUT_MODAL_OPEN_PAGE.PROFILE && (
            <ShortcutsModal
              show
              onClose={() => {
                dispatch(setShortcutModalOpenStatus(null));
              }}
              keysData={profileShortcuts}
              title="Influencer Profile Shortcuts"
            />
          )}

          {shortcutModalStatus && shortcutModalStatus === SHORTCUT_MODAL_OPEN_PAGE.RELATIONSHIP_BOARD && (
            <ShortcutsModal
              show
              onClose={() => {
                dispatch(setShortcutModalOpenStatus(null));
              }}
              keysData={relationshipShortcuts}
              title="Relationship Board Shortcuts"
            />
          )}

          {/* <SwitchUserModal
          setShowProfileDropdown={setShowProfileDropdown}
          show={switchUserModal}
          setShow={setSwitchUserModal}
        /> */}

          <OutofRatnaModal
            show={showOutofRatnaModal}
            darkMode={false}
            handleClose={() => setShowOutofRatnaModal(false)}
          />
        </div>
        <OverduePaymentHeader changeTab={changeTab} />
        <LitePlanModal show={showLitePlanModal} setShow={setShowLitePlanModal} teamLock={false} onClose={() => {}} />

        {/*<CSDowntimeBanner /> */}
      </div>
      <TrialBanner />
    </>
  );
}

const MenuWrapper = ({ children, anchorEl, open, onClose, width, maxHeight }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      elevation={1}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        elevation: 0,
        border: '1px solid #d3cdcd',
        sx: {
          overflow: 'visible',
          width: width || 'auto',
          maxHeight: maxHeight || 'auto',
          // filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': { width: 32, height: 32, ml: -0.5, mr: 1 },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}>
      {children}
    </Menu>
  );
};